import { auth } from '@/externals/gyym'
import dayjs from 'dayjs'
import store from '@/store'
import {
  StoreAuthEmailVerified,
  StoreAuthLogout,
} from '@/store/modules/auth/types'
import {
  EmailVerificationKey,
  ResendEmailParams,
  VerifyEmailParams,
} from './types'
import { OptIns } from '@/core/Auth'
import {
  ResetPasswordParams,
  DeregisterParams,
  AnalyticsParams,
} from '@/externals/gyym/auth'

export const login = async (
  email: string,
  password: string,
  remember: 0 | 1 = 1
) => {
  return await auth.login(email, password, remember)
}

export const logout = async () => {
  return await auth.logout()
}

export const getAuthUser = async () => {
  return await auth.getUser()
}

export const registerUser = async (
  email: string,
  password: string,
  passwordConfirm: string,
  campaignCode: string,
  referralSubjectCode: string | undefined,
  socialSignupToken: string | undefined,
  optIns: OptIns,
  analyticsParams: AnalyticsParams = {}
) => {
  return await auth.register({
    email,
    password,
    passwordConfirm,
    campaignCode,
    referralSubjectCode,
    socialSignupToken,
    optIns,
    ...analyticsParams,
  })
}

export const resendAuthEmail = async (params?: ResendEmailParams) => {
  return await auth.resendEmail(params)
}

export const verifyAuthEmail = async ({
  key,
  ...params
}: VerifyEmailParams & { key: EmailVerificationKey }) => {
  const res = await auth.verifyEmail(key, params)
  // 日付データさえ入ってればいいから返却値を入れるわけでなくフロントでデータを入れる
  store.commit(
    new StoreAuthEmailVerified({
      emailVerifiedAt: dayjs().format('Y-m-d H:i:s'),
    })
  )
  return res
}

export const passwordResetEmail = async (email: string) => {
  return await auth.passwordResetEmail(email)
}

export const listDeregisterQuestions = async () => {
  return await auth.listDeregisterQuestions()
}

export const deregisterUser = async (params: DeregisterParams) => {
  return await auth.deregister(params)
}

export const passwordReset = async (params: ResetPasswordParams) => {
  await auth.passwordReset(params)
  // passwordReset will force logout the user, so we need to update the store
  store.commit(new StoreAuthLogout())
}

export const directUserAuthForSocialLogin = async (
  userSocialAuthenticationId: string,
  params: {
    expires: number
    signature: string
  }
) => {
  await auth.directUserAuthForSocialLogin(userSocialAuthenticationId, params)
}
